import React from "react";
import { Route } from "react-router-dom";

export const PrivateRouteClient = ({
  component: Component,
  authed,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        authed === true ? (
          <Component {...props} />
        ) : (
          props.history.push("/client/login")
        )
      }
    />
  );
};
